// extracted by mini-css-extract-plugin
export default {"linkToSkip":"ImportHeader_linkToSkip__CzYvs"};